export const ITINERARY_PREPAYMENT_ERROR_TYPE = {
  COUPON_NOT_APPLICABLE: 'COUPON_NOT_APPLICABLE',
  PAY_URL_GENERATION_FAILED: 'PAY_URL_GENERATION_FAILED',
  PREPAYMENT_API_EXCEPTION: 'PREPAYMENT_API_EXCEPTION',
  PREPAYMENT_UNKNOWN_ERROR: 'PREPAYMENT_UNKNOWN_ERROR',
} as const

export const SENTRY_METRICS_CONFIG = {
  API_ITINERARY_CREATE_ERROR: 'api.itinerary_create_error',
  API_ITINERARY_PREPAYMENT_ERROR: 'api.itinerary_prepayment_error',
  API_SRP_ERROR: 'api.srp_error',
  FUNNEL_BOOKING_INITIATED: 'funnel.booking_initiated',
  FUNNEL_HOME_LOADED: 'funnel.home_loaded',
  FUNNEL_ITINERARY_ADDONS_PAGE_LOADED: 'funnel.itinerary_addons_page_loaded',
  FUNNEL_ITINERARY_CONTACT_PAGE_LOADED: 'funnel.itinerary_contact_page_loaded',
  FUNNEL_ITINERARY_PREPAYMENT_SUCCESS: 'funnel.itinerary_prepayment_success',
  FUNNEL_ITINERARY_REVIEW_PAGE_LOADED: 'funnel.itinerary_review_page_loaded',
  FUNNEL_ITINERARY_TRAVELLER_PAGE_LOADED: 'funnel.itinerary_traveller_page_loaded',
  FUNNEL_ITINERARY_TRAVELLER_PAYMENT_CLICK: 'funnel.itinerary_traveller_payment_click',
  FUNNEL_SEARCH_CLICKED: 'funnel.search_clicked',
  FUNNEL_SRP_LOADED: 'funnel.srp_loaded',
  FUNNEL_SRP_STARTED: 'funnel.srp_started',
} as const

export type CountMetricName = (typeof SENTRY_METRICS_CONFIG)[keyof typeof SENTRY_METRICS_CONFIG]
